import { graphql } from "@/graphql/generated";

export const addMunicipalPropertyInventorySelectionMutationDocument = graphql(/* GraphQL */ `
  mutation AddMunicipalPropertyInventorySelection($input: AddMunicipalPropertyInventorySelectionInput!) {
    addMunicipalPropertyInventorySelection(input: $input)
  }
`);
